import React from 'react';
import OrderConfirmationModal from './OrderConfirmationModal';
import RealTimeNotificationHandler from './RealTimeNotificationHandler';

const NotificationManager: React.FC = () => {
  return (
    <>
      <RealTimeNotificationHandler />
      <OrderConfirmationModal />
    </>
  );
};

export default NotificationManager;
